import React from "react";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";
import boardContentM from "../../asset/3contentM.png";
import Divider from "@mui/material/Divider";

const useStyles = makeStyles((theme: Theme) => ({
  container5: {
    // margin: "0px 20px",
    maxWidth: 824,
    width: "100%",
    marginTop: 30,
  },
  contentImageTitle: {
    fontSize: "18px",
    top: 83,
    left: 135,
    zIndex: 9,
    textAlign: "center",
    position: "absolute",
    color: "#fff",
  },
  contentImage: {},
  contentImageM: {
    position: "relative",
    width: "100%",
    maxWidth: "340px",
  },
  contentImageTable1: {
    top: 303,
    left: 47,
    width: 275,
    position: "absolute",
  },
  contentImageTable2: {
    top: 453,
    left: 53,
    width: 270,
    position: "absolute",
  },
  contentImageTable3: {
    top: 599,
    left: 44,
    width: 300,
    position: "absolute",
  },
  contentImageTd1: {
    color: "#9ed3e3",
    fontSize: "10px",
    paddingRight: 0,
    fontWight: 300,
    width: "40px",
  },
  contentImageTd11: {
    textAlign: "left",
    fontSize: "14px",
    borderBottom: "1px solid black",
    paddingBottom: 10,
    width: 115,
    fontWight: 300,
  },
  contentImageTd2: {
    color: "#dad2f3",
    fontWeight: 700,
    paddingRight: 20,
  },
  contentImageTd21: {
    textAlign: "left",
    fontSize: "14px",
    fontWeight: 500,
    borderBottom: "1px solid black",
    paddingBottom: 10,
    width: "190px",
  },
  contentImageTd3: {
    color: "#84e4df",
    fontWeight: 500,
    fontSize: 11,
    paddingRight: 15,
  },

  contentImageTd31: {
    textAlign: "left",

    fontWeight: 500,
    lineHeight: "25px",

    fontSize: 12,
  },
}));

export const Eldery3Table = () => {
  const classes = useStyles();

  return (
    <div className={classes.container5}>
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: 760,
        }}
      >
        <div
          style={{
            display: "flex",
            position: "relative",
            textAlign: "center",
            zIndex: 2,
            color: "#fff",
            fontWeight: 600,
            top: 145,
            left: 35,
          }}
        >
          중국 맞춤형 전문
          <br />
          양로 기술
          <br />
          교육 콘텐츠
        </div>
        <img
          src={boardContentM}
          alt="3contentsMobile"
          className={classes.contentImageM}
        ></img>

        {/* Knowledge 테이블 */}

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            position: "relative",
            bottom: 387,
            left: 5,
          }}
        >
          <div style={{ color: "#9ed3e3", fontSize: 10, fontWeight: 700 }}>
            Knowledge
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              fontSize: 12,
              fontWeight: 700,
              marginLeft: 20,
            }}
          >
            <div>
              노인의 이해 요양 기초 지식
              <br />
              노인대상자의 건강문제
            </div>
            <Divider
              sx={{
                borderColor: "#000",
                margin: "10px 0px",
              }}
            />
            <div>중국 노인대상자의 주요 건강문제</div>
          </div>
        </div>
        {/* Skill 테이블 */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            position: "relative",
            bottom: 305,
            left: 5,
          }}
        >
          <div style={{ color: "#dad2f3", fontSize: 10, fontWeight: 700 }}>
            Skill
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              fontSize: 12,
              fontWeight: 700,
              marginLeft: 40,
            }}
          >
            <div>상급 전문 요양 기술</div>
            <Divider
              sx={{
                borderColor: "#000",
                margin: "10px 0px",
              }}
            />
            <div>
              중국 노인 요양 기술 적용 사례
              <br />
              중국 요양 기술 관리 지침
            </div>
          </div>
        </div>
        {/* Awareness 테이블 */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            position: "relative",
            bottom: 234,
            left: 12,
          }}
        >
          <div style={{ color: "#84e4df", fontSize: 10, fontWeight: 700 }}>
            Awareness
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              fontSize: 11,
              fontWeight: 700,
              marginLeft: 20,
              lineHeight: "25px",
              letterSpacing: 0.4,
            }}
          >
            <div>
              중국 노인 대상자 이해 중국 노인 인권
              <br />
              중국 주거환경 중국 노인 임종 돌봄
              <br />
              중국 노인과의 의사소통 직업윤리
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
